var React = require('react');

function Encryptedicon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 20c-4-2-7-6-7-13l7-3 7 3c0 7-3 11-7 13z","fill":"#fff","fillOpacity":".5"}));
}

Encryptedicon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Encryptedicon;

Encryptedicon.default = Encryptedicon;
